import React, { useCallback } from 'react';
import styled from '@emotion/styled';
import PropertyCard from 'components/PropertyCard';
import { animationKeyframes } from 'lib/animations';
import { useDataLayer } from 'hooks/useDataLayer';
import { usePersonalisation } from 'hooks/usePersonalisation';

const TopCenterWrapper = styled.div`
  position: absolute;
  transform: translate(-50%, -100%) translateY(-39px);
  z-index: 1;
  min-width: 300px;
`;

const AnimationWrapper = styled.div`
  animation: ${animationKeyframes.fadeInSlideUp10} ease 250ms;
`;

const PositionedPropertyCard = (props) => {
  const { id: propertyId } = props;
  const { emitInteractionEvent } = useDataLayer();
  const personalisation = usePersonalisation();
  const handlePropertyCardClick = useCallback(() => {
    emitInteractionEvent({ type: 'Price Marker', value: 'Property Card Selected' });
    personalisation.trackMapClick(propertyId);
  }, [propertyId, personalisation, emitInteractionEvent]);

  return (
    <TopCenterWrapper>
      <AnimationWrapper data-testid="positioned-property-card-wrapper">
        <PropertyCard onClick={handlePropertyCardClick} {...props} />
      </AnimationWrapper>
    </TopCenterWrapper>
  );
};

PositionedPropertyCard.propTypes = {
  ...PropertyCard.propTypes,
};

export default PositionedPropertyCard;
